import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cCpyList from './cCpyList';

class iCpyList extends cCpyList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
//bf.l('21:here')
  }
    
  $id_stgs = {
//    cLoadCnd: () => bf.q(''),
    cLoadCnd: () => {
      let _cnd = '';
//bf.l('28:{}, {}'.f(global.c?.state.sgcd_pageCmns?.userc410, bf.n(global.c?.state.sgcd_pageCmns?.user_key)))
      if (global.c?.state.sgcd_pageCmns?.userc410 != '80') {
/*
        _cnd = bf.q('[_KEY] IN (SELECT [cm10b21k]::NUMERIC::INTEGER FROM [t_cm10] WHERE [cm10i110] IN (SELECT [cm10i110] FROM [t_cm10] WHERE [_KEY]={}))'.f(
          global.c?.state.sgcd_pageCmns?.user_key
        ));
*/
        _cnd = bf.q(`
          [_KEY] IN (
            SELECT 
              [cm10b21k]::NUMERIC::INTEGER 
            FROM 
              [t_cm10] 
            WHERE 
              [cm10i110] IN (
                SELECT 
                  [cm10i110] 
                FROM 
                  [t_cm10] 
                WHERE 
                  [_KEY]={}
              )
          )`.f(
          global.c?.state.sgcd_pageCmns?.user_key
        ));
      };
      return _cnd;
    },
  };

  render() {
//        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
//            sgc_pageRole: 'own2',
            sgc_pageName: 'iCpyDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        d_hdrs={{
          pfx: iv._get_hdrPfx('店舗一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        n_bdyW={ic.gn_w}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm20ss',
              nextRole: 'own2',
              nextPage: 'iCpyDtl',
              nextMode: 'show',
              keyName: 'cm20_key',
              pfxName: 'cm20_pfx',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
/*
            {
              type: 'Btn',
              b_vsb: (bf.n(global.c?.state.sgcd_pageCmns?.user_key) == -1) ? true: false,
              pfx: 'データ修正',
              onPrs: async () => {

                let _cm20_key = 4; // 4: 松戸, 6: 錦糸町
                let _it60d110 = '2021-10'; // 松戸：06-09, 錦糸町：09-10

                let _cnd = bf.q(`
                  it50b11k="{}" 
                  AND it50b21k=(
                    SELECT
                      [_KEY]::TEXT
                    FROM
                      t_it60
                    WHERE
                      it60b11k="{}"
                      AND it60d110="{}"
                  )
                `.f(
                  _cm20_key, 
                  _cm20_key, 
                  _it60d110,
                ));
                await cf.myCB_call_slc({
                  ctr: 'nlm', 
                  elm: 'it50', 
                  n_dms: 3, 
                  cnd: _cnd
                })
                .then( async _ld_it50ss => {

                  for await (let [_idx2, _d_it50s] of bf.e(_ld_it50ss)) {
bf.l('133: {}'.f(_d_it50s.it50d110))
                    for await (let [_idx, _timeZone] of bf.e(bf.myCM_get_rng(41, 17))) {
                      let _cnd = bf.q(`
                        [it51b11k]="{}" AND 
                        [it51d110]="{}" AND 
                        [it51d210]="{}"
                      `.f(
                        _cm20_key, 
                        _d_it50s.it50d110,
                        _timeZone
                      ));
                      await cf.myCB_call_slc({
                        ctr: 'nlm', 
                        elm: 'it51', 
                        n_dms: 2, 
                        cnd: _cnd
                      })
                      .then( async _d_it51s => {
                        if (bf.f(_d_it51s) == false) {
bf.l('168: {} {} {}: {}'.f(_cm20_key, _d_it50s.it50d110, _timeZone, _d_it51s._KEY))

                          let _d_vals = {
                            it51b11k: _cm20_key,
                            it51b21k: _d_it50s._KEY,
                            it51d110: _d_it50s.it50d110,
                            it51d210: _timeZone,
                            it51d310: bf.myDT_add_mnt('{} 00:00:00'.f(_d_it50s.it50d110), _timeZone * 60),
                            it51i110: '0',
                          };
                          let _cnd = bf.q(`
                            it51b11k="{}" AND
                            it51b21k="{}" AND
                            it51d110="{}" AND
                            it51d210="{}"
                          `.f(
                            _cm20_key,
                            _d_it50s._KEY,
                            _d_it50s.it50d110,
                            _timeZone,
                          ));
                          await cf.myCB_call_iud({
                    //        ctr: 'ups', 
                            ctr: 'ins', 
                            elm: 'it51', 
                            d_vals: _d_vals,
                            cnd: _cnd, // 強制 ins
                          })
                        }
                      });
                    };
                  };
                });
              },
            }
*/
          ],
        }}
      />
    );
  }
};

export default iCpyList;

/*
                              let _d_vals = {
                                it51b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
                                it51b21k: pd.d_it50s._KEY,
                                it51d110: pd.d_it50s.it50d110,
                                it51d210: _timeZone,
                                it51d310: bf.myDT_add_mnt('{} 00:00:00'.f(pd.d_it50s.it50d110), _timeZone * 60),
                                it51i110: '0',
                              };
                              let _cnd = bf.q(`
                                it51b11k="{}" AND
                                it51b21k="{}" AND
                                it51d110="{}" AND
                                it51d210="{}"
                              `.f(
                                global.c?.state.sgcd_pageCmns?.cm20_key,
                                pd.d_it50s._KEY,
                                pd.d_it50s.it50d110,
                                _timeZone,
                              ));
                              await cf.myCB_call_iud({
                        //        ctr: 'ups', 
                                ctr: 'ins', 
                                elm: 'it51', 
                                d_vals: _d_vals,
                                cnd: _cnd, // 強制 ins
                              })
                        //bf.l('6736: {}'.f(_timeZone))
*/

/*  
            {
              type: 'Btn',
              b_vsb: (bf.n(global.c?.state.sgcd_pageCmns?.user_key) == -1) ? true: false,
              pfx: 'データ修正',
              onPrs: async () => {
                let _cnd = bf.q(``);
                await cf.myCB_call_slc({
                  ctr: 'nlm', 
                  elm: 'cm20', 
                  n_dms: 3, 
                  cnd: _cnd
                })
                .then( _ld_cm20ss => {

                  _ld_cm20ss.map( async _d_cm20s => {
                    let _cnd = bf.q(`[it60b11k]="{}"`.f(_d_cm20s._KEY));
                    await cf.myCB_call_slc({
                      ctr: 'nlm', 
                      elm: 'it60', 
                      n_dms: 3, 
                      cnd: _cnd
                    })
                    .then( _ld_it60ss => {

                      _ld_it60ss.map( async _d_it60s => {
                        let _cnd = bf.q(`
                          [it50b11k]="{}" AND 
                          [it50b21k]="{}"
                        `.f(
                          _d_cm20s._KEY, 
                          _d_it60s._KEY
                        ));
                        await cf.myCB_call_slc({
                          ctr: 'nlm', 
                          elm: 'it50', 
                          n_dms: 3, 
                          cnd: _cnd
                        })
                        .then( _ld_it50ss => {

                          _ld_it50ss.map( _d_it50s => {
//bf.l('133: {}'.f(_d_it50s))
                            bf.myCM_get_rng(41, 17).map( async _timeZone => {
                              let _cnd = bf.q(`
                                [it51b11k]="{}" AND 
                                [it51b21k]="{}" AND 
                                [it51d110]="{}" AND 
                                [it51d210]="{}"
                              `.f(
                                _d_cm20s._KEY, 
                                _d_it50s._KEY,
                                _d_it50s.it50d110,
                                _timeZone
                              ));
                              await cf.myCB_call_slc({
                                ctr: 'nlm', 
                                elm: 'it51', 
                                n_dms: 2, 
                                cnd: _cnd
                              })
                              .then( _d_it51s => {
if (!_d_it51s) bf.l('168: {} {} {}'.f(_d_cm20s._KEY, _d_it50s.it50d110, _timeZone))
                              });
                            });
                          });
                        });
                      });
                    });
                  });
                });
              },
            }
*/
